'use client';

import { useEffect, useState } from 'react';

// * useDebounce returns a debounced copy of the provided value.
// * It updates only after the given delay has elapsed without further changes.
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
